import { SVGProps } from "react"

const X2Icon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33 60.5C48.125 60.5 60.5 48.125 60.5 33C60.5 17.875 48.125 5.5 33 5.5C17.875 5.5 5.5 17.875 5.5 33C5.5 48.125 17.875 60.5 33 60.5Z"
        stroke="#C41407"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2178 40.7818L40.7828 25.2168"
        stroke="#C41407"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.7828 40.7818L25.2178 25.2168"
        stroke="#C41407"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default X2Icon
